import { render, staticRenderFns } from "./qyfc.vue?vue&type=template&id=bad8b75e&scoped=true"
import script from "./qyfc.vue?vue&type=script&lang=js"
export * from "./qyfc.vue?vue&type=script&lang=js"
import style0 from "./qyfc.vue?vue&type=style&index=0&id=bad8b75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad8b75e",
  null
  
)

export default component.exports